<mat-dialog-content>
  <t4-container title="{{ 'Turbo.Settings.EditOpenHours.Headline' | translate : 'Edit open hours' }} - {{ 'Turbo.Settings.EditOpenHours.WeekDayName_' + dayOfWeek | translate: weekDay }} ">
    <div class="row">
      <div class="col-xs-6">
        <h5>{{ 'Turbo.Settings.EditOpenHours.lblOpens' | translate : 'Opens' }}</h5>
        <t4-timePicker [(selectedTime)]="startTime" steps="quarter"></t4-timePicker>
      </div>
      <div class="col-xs-6">
        <h5>{{ 'Turbo.Settings.EditOpenHours.lblCloses' | translate : 'Closes' }}</h5>
        <t4-timePicker [(selectedTime)]="endTime" steps="quarter"></t4-timePicker>
      </div>
    </div>
    <div>
      <mat-checkbox style="margin:10px;" [(ngModel)]="closed">{{ 'Turbo.Settings.EditOpenHours.lblClosed' | translate : 'Closed' }}</mat-checkbox>
    </div>
  </t4-container>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="primary" style="margin: 5px;" (click)="save()">{{ 'Turbo.Settings.EditOpenHours.cmdSave' | translate : 'Save' }}</button>
  <button mat-button style="margin: 5px;" [mat-dialog-close]>{{ 'Turbo.Settings.EditOpenHours.cmdCancel' | translate : 'Cancel' }}</button>
</mat-dialog-actions>
